import * as Yup from "yup";

import { TextManager } from "Components/TextContext";

export const emailSchema = (): Yup.StringSchema<string> => {
  const { getText } = TextManager;
  return Yup.string()
    .email(getText("customerform.validation.email-format"))
    .min(2, getText("customerform.validation.email-minimum"))
    .max(50, getText("customerform.validation.email-maximum"))
    .required(getText("customerform.validation.email-required"));
};
